import { Platform } from "react-native";
import { check, PERMISSIONS, RESULTS } from "react-native-permissions";
import { getCurrentLocation } from "@utils/getCurrentLocation";

const location = { lng: null, lat: null };

const useLocation = async () => {
  let result = location;

  if (Platform.OS === "android") {
    const status = await check(PERMISSIONS.ANDROID.ACCESS_FINE_LOCATION);
    if (status === RESULTS.GRANTED) {
      try {
        const { coords } = await getCurrentLocation({ timeoutMs: 8000 });
        result = { lat: coords.latitude, lng: coords.longitude };
      } catch (e) {
        console.log("Geolocation_err", e);
      }
    }
  }
  return result;
};

export default useLocation;
